module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/visa@2x-90aeca76c17657a252749884a9059ee2.png";